/**
 * 10.9GA — ÍNDICE (coletânea): mostra TODOS os equipamentos do jogo (armas + roupas), agrupados
 * por TIER, marcando o que o Caçador já descobriu (viu/pegou). O que falta aparece como "???".
 * Serve pra saber o que existe e o que ainda dá pra caçar. Só leitura.
 */
import { i18n } from "../i18n/i18n";
import { weaponDefs, armorDefs } from "../items/Catalog";
import type { EquipmentDefinition } from "../items/EquipmentTypes";

const SLOT_ICON: Record<string, string> = { weapon: "⚔️", head: "⛑️", chest: "\u{1F9BA}", gloves: "\u{1F9E4}", boots: "\u{1F97E}", accessory: "\u{1F48D}" };

export class IndexScreen {
  private readonly root: HTMLDivElement;

  constructor(uiRoot: HTMLElement, private readonly onClose: () => void) {
    this.root = document.createElement("div");
    this.root.className = "overlay index-overlay";
    this.root.hidden = true;
    uiRoot.appendChild(this.root);
  }

  hide(): void { this.root.hidden = true; }

  open(discovered: string[]): void {
    const seen = new Set(discovered);
    const esc = (t: string): string => t.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]!));
    // agrupa por tier (arma tem tier no fim de jogo; base = tier 1)
    const all: EquipmentDefinition[] = [...weaponDefs(), ...armorDefs()].filter((d) => !(d as { protects?: string }).protects);
    const byTier = new Map<number, EquipmentDefinition[]>();
    for (const d of all) {
      const t = (d as { tier?: number }).tier ?? 1;
      if (!byTier.has(t)) byTier.set(t, []);
      byTier.get(t)!.push(d);
    }
    const tiers = [...byTier.keys()].sort((a, b) => a - b);
    const total = all.length, got = all.filter((d) => seen.has(d.id)).length;
    let html = `<div class="panel index-panel"><button class="close-x" data-a="close">✕</button>
      <h2>\u{1F4D5} ${esc(i18n.t("index.title"))}</h2>
      <div class="index-count">${esc(i18n.t("index.count", { got: String(got), total: String(total) }))}</div>`;
    for (const t of tiers) {
      const items = byTier.get(t)!;
      const g = items.filter((d) => seen.has(d.id)).length;
      html += `<div class="index-tier"><span>${esc(i18n.t("index.tier", { n: String(t) }))}</span><small>${g}/${items.length}</small></div><div class="index-grid">`;
      for (const d of items) {
        const has = seen.has(d.id);
        html += `<div class="index-cell${has ? "" : " locked"}" title="${has ? esc(i18n.t(d.nameKey)) : "???"}">
          <span class="ix-ic">${has ? SLOT_ICON[d.slot] ?? "✨" : "❓"}</span>
          <span class="ix-nm">${has ? esc(i18n.t(d.nameKey)) : "???"}</span></div>`;
      }
      html += `</div>`;
    }
    html += `</div>`;
    this.root.innerHTML = html;
    this.root.querySelector<HTMLButtonElement>('[data-a="close"]')!.onclick = () => this.onClose();
    this.root.hidden = false;
  }
}
